import type { IDurationData } from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export type Granularities = "Daily" | "Weekly" | "Monthly";

export interface IGranularityDesc {
    title: string;
    disabled: boolean;
    index: number;
    value: Granularities;
}

export const getAvailableGranularities = (
    durationObj: IDurationData,
    webSource: string = devicesTypes.DESKTOP,
): IGranularityDesc[] => {
    const durationRaw = durationObj?.raw;
    const monthDiff = durationRaw.to.diff(durationRaw.from, "month");
    return [
        {
            title: "D",
            disabled: true,
            index: 0,
            value: "Daily",
        },
        {
            title: "W",
            disabled: webSource === devicesTypes.TOTAL,
            index: 1,
            value: "Weekly",
        },
        {
            title: "M",
            disabled: webSource !== devicesTypes.TOTAL && monthDiff < 1,
            index: 2,
            value: "Monthly",
        },
    ];
};
